<template>
    <v-form ref="form" v-model="valid" lazy-validation>
    <v-text-field v-model="phoneModel.AssetTag" :rules="nameRules" label="Asset Tag" required></v-text-field>
    <v-text-field v-model="phoneModel.Serial" :rules="nameRules" label="Serial" required></v-text-field>
     <v-select
      v-model="phoneModel.Brand"
      :items="phoneBrands"
      :rules="nameRules"
      label="Brand"
      required
    ></v-select>
        <v-text-field v-model="phoneModel.Imei"  label="Imei"></v-text-field>
    <v-text-field v-model="phoneModel.Model" label="Model" required></v-text-field>
    <v-btn color="primary" @click="submit">submit</v-btn>
  </v-form>
</template>

<script>
import { mapFields } from "vuex-map-fields";
const fb = require("../firebaseConfig.js");
export default {
    mounted()  {
      fb.SettingsCollections.doc("searchDropDownValue").onSnapshot(doc => {
      this.phoneBrands = doc.data().phonebrandSetting;
      });
    },
    methods : {
          validate() {
      if (this.$refs.form.validate()) {
        this.valid = true;
      } else {
        this.valid = false;
      }
    },
    submit() {
      this.validate();
      if (!this.valid) {
        return;
      }
      var dbobject = {
        Discovery: this.phoneModel,
        Time: this.$moment().format("MM/DD/YYYY HH:mm:ss"),
        AssetType: "phone"
      };
      var ref = fb.AssetsCollections.doc(this.phoneModel.AssetTag);
      ref.get().then(docSnapshot => {
        if (!docSnapshot.exists) {
          fb.AssetsCollections.doc(this.phoneModel.AssetTag)
            .set(dbobject)
            .then(() => {
              this.$emit("closeForm");
            })
            .catch(function(error) {
        
            });
         
        } else {
          this.$emit("duplicate")
        }
      });
    }
    },
    data(){
        return{
            phoneBrands : [],
            valid: false,
            nameRules: [v => !!v || "This Field is required"],
        phoneModel: {
        AssetTag: "",
        Imei: "",
        Serial: "",
        Brand: "",
        Model : "",
        Time: this.$moment().format("MM/DD/YYYY HH:mm:ss"),
        Status: "ready"
      }
        }
    }
}
</script>
